import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
const containerCss = "cood20w";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const spacingCss = "s15f2ols";
const Spacing = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(spacingCss, props.className)} />;
});
const SingleState = () => {
  const userUrl = '/app/admin/users';
  const inviteUrl = '/app/admin/invitations/new';
  return <Container>
      <Spacing>
        {I18n.t('publisher.event_types.scope_dropdown.organization.title')}
      </Spacing>
      <Spacing>
        {I18n.t('publisher.event_types.scope_dropdown.organization.description')}
      </Spacing>
      <Spacing>
        <Link as={RouterLink} to={userUrl}>
          {I18n.t('publisher.event_types.scope_dropdown.organization.learn_more')}
        </Link>
      </Spacing>
      <Link as={RouterLink} to={inviteUrl}>
        {I18n.t('publisher.title.add_seats')}
      </Link>
    </Container>;
};
export default SingleState;

require("./single_state.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./single_state.js");